<template>
    <header>
        <div class="topline">
            <div class="holder">
                <div class="wrap">
                    <div id="bl-geo">
                        Вы находитесь: <a href="#" class="curr"><span id="municipality_name_span"></span></a>
                    </div>

                    <div id="visual-version">
                        <span class="label">Слабовидящим</span>
                    </div>

                    <div id="bl-account">
                        <span v-if="props.authorizedUser != null"
                              class="hello">Здравствуйте, {{props.authorizedUser.formattedUserName}}</span>
                        <a v-if="props.authorizedUser == null" v-bind:href="getEsiaUrl()" class="enter">Войти</a>
                        <a v-else href="/appeals" class="my">Мои обращения</a>
                        <a v-if="props.authorizedUser != null" href="javascript:;" v-on:click="logout" class="logout">Выйти</a>
                    </div>
                </div>
            </div>
        </div>

        <div class="holder">
            <div class="wrap">

                <a href="/" id="logo">
                  <img src="../assets/images/logo.png"
                       alt="Государственная информационная система Омской области «Аппаратно-программный комплекс технических средств «Безопасный город»"
                       title="Государственная информационная система Омской области «Аппаратно-программный комплекс технических средств «Безопасный город»">
                  <span>Государственная информационная система Омской области «Аппаратно-программный комплекс технических средств «Безопасный город»</span>
                </a>


                <div id="menu-holder">
                    <nav id="menu-main">
                        <ul>
                            <li><a href="/news">Новости</a></li>
                            <li><a href="/documents">Документы</a></li>
                            <li><a href="/contacts">Контакты ЕДДС МО</a></li>
                        </ul>
                    </nav>
                    <div class="close"></div>
                </div>

                <a href="tel:112" id="tel"><span>Телефон вызова экстренных оперативных служб:</span>112</a>

                <a v-bind:href="props.authorizedUser == null ? getEsiaUrl() : '/appeal'" class="btn-appeal btn"><span>Подать обращение</span></a>
            </div>
        </div>
    </header>

</template>

<script>
    export default {
        components: {},
        data: function () {
            return {
                props: Application.props,
                providers: UserAPI.authProviders(),
//                authUrl: 'http://safecity.amfitel.ru:2111/aas/oauth2/ac?response_type=code&client_id=esia&redirect_uri=http%3A%2F%2Fsafecity.amfitel.ru%2Fscy-core-web-1.0%2Fplatform%2Foauth%2FESIA'
            }
        },
        created: function () {

        },
        methods: {
            logout: function () {
                UserAPI.logout(Application.onCompleteLogout);
            },
            getEsiaUrl: function () {
                for (let i = 0; i < this.providers.length; i++) {
                    let provider = this.providers[i];
                    if (provider.name == 'esia') {
                        return provider.url;
                    }
                }
                return "";
            },

            getMunicipality: function() {
                return Application.getCurrentMunicipality();
            },
        }
    }


</script>


// WEBPACK FOOTER //
// VHeader.vue?03628f1e